exports = module.exports = require("../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".style-comment-anchor-container-3QB1w{position:absolute;top:4px;left:-25px;width:24px;height:24px;display:flex;flex-direction:column;pointer-events:auto}.style-comment-anchor-container-3QB1w .style-comment-anchor-count-2PDEY{color:#fff;font-size:10px;font-weight:400;text-align:center;width:24px;height:24px;line-height:24px}", ""]);

// Exports
exports.locals = {
	"comment-anchor-container": "style-comment-anchor-container-3QB1w",
	"comment-anchor-count": "style-comment-anchor-count-2PDEY"
};